<!-- svelte-ignore a11y-missing-attribute -->

{#if false && data.status != 'ended'}
  {#if matches.length == 1}
    <article class="message is-success">
      <div class="message-body">
        <p>
          You have a match! If your offer is only partially requested, you may
          select additional requests on the 'Requests' tab.
        </p>
        <!-- svelte-ignore a11y-missing-attribute -->
        <p>
          To stop receiving further requests, please <a
            on:click={() => {
              $uiState.activeModal = {
                component: ConfirmClose,
                props: { id: id },
              };
            }}>end the offer</a
          >.
        </p>
      </div>
    </article>
  {:else}
    <article class="message is-success">
      <div class="message-body">
        <p>
          If your offer is only partially requested, you may select additional
          requests on the 'Requests' tab.
        </p>
      </div>
    </article>
  {/if}

  
{/if}

{#if matches.length == 1}

<div class="box">

  {#if allMatched && data.status != 'ended'}

  <article class="message is-info">
    <div class="message-body">
      <!-- svelte-ignore a11y-missing-attribute -->
      <p>
        Your offer is still published. To stop receiving further requests, please <a
          on:click={() => {
            $uiState.activeModal = {
              component: ConfirmClose,
              props: { id: id },
            };
          }}>end the offer</a
        >.
      </p>
    </div>
  </article>

  {/if}

  <RequestDetails requestId={matches[0].id} />
</div>
{:else if matches.length > 1}

<div class="box">

  {#if allMatched && data.status != 'ended'}

  <article class="message is-info">
    <div class="message-body">
      <!-- svelte-ignore a11y-missing-attribute -->
      <p>
        Your offer is still published. To stop receiving further requests, please <a
          on:click={() => {
            $uiState.activeModal = {
              component: ConfirmClose,
              props: { id: id },
            };
          }}>end the offer</a
        >.
      </p>
    </div>
  </article>

  {/if}

  <table class="table is-fullwidth is-hoverable">
    <tbody>
      {#each matches as request}
        <tr>
          <td>
            <a href={$url('../../../request/' + request.id)}>{request.data.charity.name}</a>
            {#if request.data.message}
              <Message
                >{request.data.message.substring(0, 100)}
                {#if request.data.message.length > 100}...{/if}</Message
              >
            {/if}
          </td>
          <td>
            <RequestStatusTag status={request.data.status || 'new'} />
          </td>
        </tr>
      {/each}
    </tbody>
  </table>
  </div>

{/if}

<script lang="ts">
  export let scoped : { id: OfferId, data: Offer_v2, requests: Request_v2_Doc[] };
  import _ from 'lodash';
  import { uiState } from '../../../../lib/uiState';
  import { url } from '@sveltech/routify';
  import ConfirmClose from './_components/ConfirmClose.svelte';
  import RequestDetails from './_components/RequestDetails.svelte';
  import Message from '../../../_components/Message.svelte';
  import RequestStatusTag from '../../../_components/RequestStatusTag.svelte';

  let id: string = scoped.id;
  $: data = scoped.data;
  $: requests = scoped.requests || [];

  $: matches = requests.filter(
    (req) => req.data.status === 'selected' || req.data.status === 'matched' || req.data.status === 'completed'
  );

  $: allMatched = matches.find( (req) => req.data.status === 'selected' ) == undefined;
</script>
